import { useMemo } from 'react';

import { useGetProjectQuery } from '../api';
import { projectDetailsTransformer } from '../helpers/detail-view-transformer';

export function useProjectDetails(id: string) {
  const { data: project } = useGetProjectQuery({ id: id });
  const normalizedProject = useMemo(() => projectDetailsTransformer(project), [project]);
  return { project, normalizedProject } as const;
}

export function useTechnologyDetails(projectId: string, technologyId: number) {
  const { normalizedProject: project } = useProjectDetails(projectId);
  return useMemo(
    () => project?.technologies.find((technology) => technology.id === technologyId),
    [project, technologyId]
  );
}

export function useOpportunityProjectIds(opportunity: any){

  return useMemo(() => {
    const list = Array.isArray(opportunity?.projects) ? opportunity.projects : [];
    return list
      .map((p: any) => {
        const details = p?.details as { id?: string } | string | null | undefined;
        if (!details) return undefined;
        return typeof details === 'string' ? details : details.id;
      })
      .filter((v: any): v is string => Boolean(v));
  }, [opportunity?.projects]);
}
